exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".glyphicon.icon-arrow-right:before{content:\"\\E092\"}.glyphicon.icon-arrow-left:before{content:\"\\E091\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/scss/common/plugin.scss
// module id = 598
// module chunks = 2